import Vue from 'vue';

import Const from '@/constants';

import ObjectHelper from '@/helper/objectHelper';

import ObjectSetupService from '@/api/objectsetup';
import TaggerService from '@/api/tagger';

export default {
	state: {
		language: '',
		current: {},
		loading: true,
		statusWaiting: false,
	},

	mutations: {
		setObjectLanguage(state, lang) {
			state.language = lang;
		},

		setObjectSetup(state, object) {
			/* Vervollständigung der Gattungseinträge (S_Gattung) auf Basis
				der 'FKM_Gattung'-Eintträge und 'gattungen'-Eintrags */
			[1, 2, 3, 4, 5, 6].forEach((num) => {
				const propNamePostfix = (num === 1) ? '' : `${num}`;
				const idPropName = `FKM_Gattung${propNamePostfix}`;
				const titlePropName = `S_Gattung${propNamePostfix}`;

				const id = object[idPropName] || '0';
				let title = object[titlePropName] || '';

				const foundGattung = object.gattungen.find(currGattung => currGattung.PKM_Gattung === id);

				if (foundGattung) {
					title = foundGattung.S_Gattung;
				}

				object[idPropName] = id;
				object[titlePropName] = title;
			});

			state.current = object;
		},

		setObjectLoading(state, loading) {
			state.loading = loading;
		},

		updateObjectSetupObjectname(state, objectname) {
			Object.keys(objectname).forEach((langKey) => {
				state.current[`S_${langKey}_Objekt`] = objectname[langKey];
			});
		},

		updateObjectSetupURL(state, newURL) {
			state.current.S_URL_Objekt = newURL;
		},

		updateObjectSetupObjectAdditional(state, objectAdditional) {
			state.current.S_Zusatz = objectAdditional;
		},
		updateObjectSetupObjectEditor(state, objectEditor) {
			state.current.FKM_Nutzername_Redakteur = objectEditor;
		},
		updateObjectSetupObjectDesigner(state, objectDesigner) {
			state.current.FKM_Nutzername_Designer = objectDesigner;
		},

		updateObjectSetupSpecification(state, specification) {
			state.current.S_Spezifikation = specification;
		},

		updateObjectSetupLightscoutClassification(state, lang) {
			const langPropName = `S_${lang.code}_Objekt`;
			const currValue = state.current[langPropName];

			if (lang.value && currValue === Const.NO_CONTENT) {
				state.current[langPropName] = '';
			} else {
				state.current[langPropName] = Const.NO_CONTENT;
			}

			state.current.sprachen[lang.code] = lang.value;
		},

		updateObjectSetupVisibility(state, visibleStr) {
			state.current.B_Sichtbar = visibleStr;
		},

		updateObjectSetupSynchblock(state, synchStr) {
			state.current.B_Synchblock = synchStr;
		},

		updateObjectSetupStatus(state, status) {
			state.current.FKM_Status = status;
		},

		updateObjectSetupPkStatus(state, { index, value }) {
			state.current[`FKM_PK_Status_${index}`] = value;
		},

		updateObjectSetupStatusWaiting(state, waiting) {
			state.statusWaiting = waiting;
		},

		updateObjectSetupBasisGenus(state, genus) {
			Object.keys(genus).forEach((genusKey) => {
				const genusData = genus[genusKey];

				const propNamePostfix = (genusData.type === 'basis') ? '' : genusKey;
				const idPropName = `FKM_Gattung${propNamePostfix}`;
				const titlePropName = `S_Gattung${propNamePostfix}`;

				if (genusData.id) {
					Vue.set(state.current, idPropName, genusData.id);
					Vue.set(state.current, titlePropName, genusData.value);
				} else {
					Vue.set(state.current, idPropName, '0');
					Vue.set(state.current, titlePropName, '');
				}
			});
		},

		updateObjectSetupTriad(state, triad) {
			Object.keys(triad).forEach((branchKey) => {
				const branch = triad[branchKey];
				Object.keys(branch).forEach((groupKey) => {
					const group = branch[groupKey];
					Object.keys(group).forEach((itemKey) => {
						const itemValue = group[itemKey];

						state.current.dreiklang[branchKey].forEach((branchGroup) => {
							if (branchGroup.PKM_Gattung === groupKey.toString()) {
								branchGroup.objekte.forEach((groupItem) => {
									if (groupItem.PKM_Objekt === itemKey.toString()) {
										groupItem.selected = itemValue.toString();
									}
								});
							}
						});
					});
				});
			});
		},

		updateObjectSetupLinkedProducts(state, linkedProducts) {
			Object.keys(linkedProducts).forEach((branchKey) => {
				const branch = linkedProducts[branchKey];
				Object.keys(branch).forEach((groupKey) => {
					const group = branch[groupKey];
					Object.keys(group).forEach((itemKey) => {
						const itemValue = group[itemKey];

						state.current.verwendete_produkte[branchKey].forEach((branchGroup) => {
							if (branchGroup.PKM_Gattung.toString() === groupKey.toString()) {
								branchGroup.objekte.forEach((groupItem) => {
									if (groupItem.PKM_Objekt.toString() === itemKey.toString()) {
										groupItem.selected = itemValue.toString();
									}
								});
							}
						});
					});
				});
			});
		},

		updateObjectSetupPublishDateTime(state, datetime) {
			state.current.TS_online_Liveserver = datetime;
		},

		updateObjectSetupGoOfflineDateTime(state, datetime) {
			state.current.TS_offline_Liveserver = datetime;
		},

		updateObjectSetupCategories(state, tags) {
			state.current.tags = tags;
		},

		updateObjectSetupMediaformats(state, tags) {
			state.current.tags = tags;
		},

		updateObjectProjectToCountry(state, countryId) {
			/* TODO: Nach Auslagerung der land-Eigenschaft,
			         sollte die Aktualisierung der Landzuordnung angepasst werden */
			const currentlySelectedCountryIndex =
				state.current.land.findIndex(country => country.selected === 'true');

			if (currentlySelectedCountryIndex >= 0) {
				state.current.land[currentlySelectedCountryIndex].selected = 'false';
			}


			const newlySelectedCountryIndex =
				state.current.land.findIndex(country => country.PKM_Land === countryId);

			if (newlySelectedCountryIndex) {
				state.current.land[newlySelectedCountryIndex].selected = 'true';
			}
		},
	},

	actions: {
		setObjectLanguage({ commit }, lang) {
			window.document.cookie = `lang=${encodeURIComponent(lang)}`;
			commit('setObjectLanguage', lang);
		},

		getObjectSetup({ commit, dispatch }, requestData) {
			commit('setObjectLoading', true);

			return new Promise((resolve, reject) => {
				ObjectSetupService.get(requestData.id, requestData.lang)
				.then((response) => {
					commit('setObjectSetup', response);
					commit('setObjectLoading', false);

					dispatch('fetchCountries');

					resolve();
				})
				.catch((e) => {
					commit('setObjectLoading', false);
					reject(e);
				});
			});
		},

		getObjectSetupWithSites({ commit, state, dispatch }, requestData) {
			return new Promise((resolve, reject) => {
				const id = (requestData && requestData.id) || (state.current && state.current.PKM_Objekt);
				const lang = (requestData && requestData.lang) || (state.current && state.current.sprache);

				dispatch('getObjectSetup', { id, lang })
				.then(() => {
					dispatch('getLayoutTemplates');

					/* Jetzt noch die Objekt-Seiten beziehen */
					const sites = state.current.seiten;
					dispatch('getObjectSites', { sites, lang });
					resolve();
				})
				.catch((e) => {
					reject(e);
				});
			});
		},

		updateObjectSetup({ commit, state }, objectData) {
			commit('setObjectSetup', objectData);
			return ObjectSetupService.set(state.current.PKM_Objekt, {
				objectData,
			});
		},

		updateObjectSetupObjectname({ commit, state, dispatch }, objectname) {
			commit('updateObjectSetupObjectname', objectname);

			const objectnameObj = {};
			Object.keys(objectname).forEach((langKey) => {
				objectnameObj[`S_${langKey}_Objekt`] = objectname[langKey];
			});

			return new Promise((resolve, reject) => {
				ObjectSetupService.set(state.current.PKM_Objekt, objectnameObj)
				.then((resp) => {
					dispatch('updateDashboardObjectNames', [{ id: state.current.PKM_Objekt, name: objectname }]);
					resolve(resp);
				})
				.catch((e) => {
					reject(e);
				});
			});
		},

		updateObjectSetupObjectAdditional({ commit, state }, objectAdditional) {
			if (typeof objectAdditional.objectadditional === 'string') {
				commit('updateObjectSetupObjectAdditional', objectAdditional.objectadditional);
				return ObjectSetupService.set(state.current.PKM_Objekt, {
					S_Zusatz: objectAdditional.objectadditional,
				});
			}
			return Promise.reject();
		},


		updateObjectSetupObjectEditor({ commit, state }, objectEditor) {
			if (typeof objectEditor.objecteditor === 'string') {
				commit('updateObjectSetupObjectEditor', objectEditor.objecteditor);
				return ObjectSetupService.set(state.current.PKM_Objekt, {
					FKM_Nutzername_Redakteur: objectEditor.objecteditor,
				});
			}
			return Promise.reject();
		},

		updateObjectSetupObjectDesigner({ commit, state }, objectDesigner) {
			if (typeof objectDesigner.objectdesigner === 'string') {
				commit('updateObjectSetupObjectDesigner', objectDesigner.objectdesigner);
				return ObjectSetupService.set(state.current.PKM_Objekt, {
					FKM_Nutzername_Designer: objectDesigner.objectdesigner,
				});
			}
			return Promise.reject();
		},

		updateObjectSetupSpecification({ commit, state }, specification) {
			if (typeof specification.specification === 'string') {
				commit('updateObjectSetupSpecification', specification.specification);
				return ObjectSetupService.set(state.current.PKM_Objekt, {
					S_Spezifikation: specification.specification,
				});
			}
			return new Promise((resolve, reject) => reject());
		},

		updateObjectSetupLightscoutClassification({ commit, state }, lang) {
			const langPropName = `S_${lang.code}_Objekt`;
			const currValue = state.current[langPropName];
			const data = {};

			if (lang.value && currValue === Const.NO_CONTENT) {
				data[langPropName] = '';
			} else {
				data[langPropName] = Const.NO_CONTENT;
			}

			return new Promise((resolve, reject) => {
				ObjectSetupService.set(state.current.PKM_Objekt, data)
				.then((response) => {
					commit('updateObjectSetupLightscoutClassification', lang);
					resolve(response);
				})
				.catch((e) => {
					reject(e);
				});
			});
		},

		updateObjectSetupVisibility({ commit, state }, visible) {
			const valStr = visible ? 'j' : 'n';
			const data = {
				B_Sichtbar: valStr,
			};
			return new Promise((resolve, reject) => {
				ObjectSetupService.set(state.current.PKM_Objekt, data)
				.then((response) => {
					commit('updateObjectSetupVisibility', valStr);
					resolve(response);
				})
				.catch((e) => {
					reject(e);
				});
			});
		},

		updateObjectSetupSynchblock({ commit, state }, synchblock) {
			const valStr = synchblock ? 'j' : 'n';
			const data = {
				B_Synchblock: valStr,
			};
			return new Promise((resolve, reject) => {
				ObjectSetupService.set(state.current.PKM_Objekt, data)
				.then((response) => {
					commit('updateObjectSetupSynchblock', valStr);
					resolve(response);
				})
				.catch((e) => {
					reject(e);
				});
			});
		},

		updateObjectSetupStatus({ commit, state, getters, dispatch }, data) {
			commit('updateObjectSetupStatusWaiting', true);

			return new Promise((resolve, reject) => {
				const lang = data.passLang ? state.current.sprache : null;
				const additionalParams = {};

				if (data.mode) {
					additionalParams.mode = data.mode;
				}

				ObjectSetupService.statusSet(state.current.PKM_Objekt, data.status, lang, additionalParams)
				.then((resp) => {
					if (typeof data.status === 'undefined') {
						throw new Error('No status passed to "updateObjectSetupStatus"-action!');
					}

					const newStatus = parseInt(data.status, 10);
					/* Wenn wir nur die Preview erstellen / erneuern, oder das Objekt synchronisieren,
					   soll der Status im Store nicht aktualisiert werden */
					if (data.mode !== 'preview' &&
					    newStatus !== getters.statiAssoc.synchronize) {
						commit('updateObjectSetupStatus', newStatus);
					}

					let objURL = (resp.objekt_staging_url) ? resp.objekt_staging_url : '';

					if (objURL === '' && newStatus === getters.statiAssoc.synchronize) {
						objURL = state.current.S_URL_Objekt;
					}

					commit('updateObjectSetupURL', objURL);
					commit('updateObjectSetupStatusWaiting', false);

					if (newStatus === getters.statiAssoc.online) {
						commit('updateObjectSetupPublishDateTime', resp.TS_online_Liveserver)
					    .then(resolve)
					    .catch(reject);
					} else {
						resolve();
					}
				})
				.catch((err) => {
					commit('updateObjectSetupStatusWaiting', false);
					reject(err);
				});
			});
		},

		clearLightscoutCacheEntry({ commit, state }) {
			commit('updateObjectSetupStatusWaiting', true);

			return ObjectSetupService.clearLightscoutCacheEntry(state.current.PKM_Objekt)
			.then((message) => {
				alert(message.trim()); // eslint-disable-line no-alert
			})
			.catch((err) => {
				alert(`Cache konnte nicht geleert werden: ${err}`); // eslint-disable-line no-alert
			})
			.finally(() => {
				commit('updateObjectSetupStatusWaiting', false);
			});
		},

		updateObjectSetupPkStatus({ commit, state }, data) {
			commit('updateObjectSetupPkStatus', { index: data.S_Modus, value: data.PKM_Status });

			return ObjectSetupService.pkStatusSet(state.current.PKM_Objekt, data.PKM_Status);
		},

		updateObjectSetupBasisGenus({ commit, state }, genus) {
			commit('updateObjectSetupBasisGenus', genus);

			const gattung = {};
			Object.keys(genus).forEach((index) => {
				switch (index) {

					case '0':
						gattung.FKM_Gattung = genus[index].id || '0';
						break;

					case '2': case '3':
					case '4': case '5':
					case '6':
						gattung[`FKM_Gattung${index}`] = genus[index].id || '0';
						break;

					default:
				}
			});

			return ObjectSetupService.set(state.current.PKM_Objekt, gattung);
		},

		updateObjectSetupTriad({ commit, state }, triad) {
			const triadCopy = JSON.parse(JSON.stringify(triad));
			commit('updateObjectSetupTriad', triad);

			Object.keys(triad).forEach((branchKey) => {
				triadCopy[branchKey] = Object.keys(triad[branchKey]).map((groupKey) => {
					const groupObj = {
						PKM_Gattung: groupKey,
						objekte: Object.keys(triad[branchKey][groupKey]).map((itemKey) => {
							const itemObj = {
								PKM_Objekt: itemKey,
								selected: triad[branchKey][groupKey][itemKey],
							};
							return itemObj;
						}),
					};
					return groupObj;
				});
			});

			return ObjectSetupService.set(state.current.PKM_Objekt, { dreiklang: triadCopy });
		},

		updateObjectSetupLinkedProducts({ commit, state }, linkedProducts) {
			const linkedProductsCopy = JSON.parse(JSON.stringify(linkedProducts));
			commit('updateObjectSetupLinkedProducts', linkedProducts);

			Object.keys(linkedProducts).forEach((branchKey) => {
				linkedProductsCopy[branchKey] = Object.keys(linkedProducts[branchKey]).map((groupKey) => {
					const groupObj = {
						PKM_Gattung: groupKey.toString(),
						objekte: Object.keys(linkedProducts[branchKey][groupKey]).map((itemKey) => {
							const itemObj = {
								PKM_Objekt: itemKey,
								selected: linkedProducts[branchKey][groupKey][itemKey],
							};
							return itemObj;
						}),
					};
					return groupObj;
				});
			});

			return ObjectSetupService.set(
				state.current.PKM_Objekt,
				{
					verwendete_produkte: linkedProductsCopy,
				},
			);
		},

		updateObjectSetupPublishDateTime({ commit, state }, datetime) {
			return new Promise((resolve, reject) =>
				ObjectSetupService.set(state.current.PKM_Objekt, {
					TS_online_Liveserver: datetime,
				})
				.then((resp) => {
					commit('updateObjectSetupPublishDateTime', datetime);
					resolve(resp);
				})
				.catch(reject),
			);
		},

		updateObjectSetupGoOfflineDateTime({ commit, state }, datetime) {
			return new Promise((resolve, reject) =>
				ObjectSetupService.set(state.current.PKM_Objekt, {
					TS_offline_Liveserver: datetime,
				})
				.then((resp) => {
					commit('updateObjectSetupGoOfflineDateTime', datetime);
					resolve(resp);
				})
				.catch(reject),
			);
		},

		updateObjectSetupCategories({ commit, state }, categories) {
			const initialTagIDMap = {};

			Object.keys(state.current.tags.result).forEach((tagID) => {
				const currInitTag = state.current.tags.result[tagID];
				initialTagIDMap[currInitTag.S_Value] = tagID;
			});

			/* Sofern der Tag und seine ID bereits bekannt sein,
				dann setzen wir sie hier nochmal, da es sein kann,
				dass die von der Sidebar überreichten Tags keine ID vorweisen können */
			Object.keys(categories.tags).forEach((tag) => {
				const currTag = categories.tags[tag];
				if (initialTagIDMap[tag]) {
					categories.tags[tag].id = initialTagIDMap[tag];
				}

				/* Tag-Aktionen überspringen, bei denen Tags entfernt werden sollen,
					die keine ID besitzen -> wahrscheinlich ein Tag,
					der hinzugefügt und dann wieder entfernt wurde */
				if (currTag.action === 'remove' && currTag.id === null) {
					delete categories.tags[tag];
				}
			});


			const tagSetPromises = Object.keys(categories.tags).map((tag) => {
				const currTag = categories.tags[tag];

				if (currTag.action === 'add') {
					return TaggerService.setTag(
						state.current.PKM_Objekt,
						Object.values(currTag.value)[0],
						currTag.value);
				}

				return TaggerService.deleteTag(currTag.id, currTag.value);
			});

			const promisifiedTagActions = Promise.all(tagSetPromises);

			return new Promise((resolve, reject) => {
				promisifiedTagActions
					.then(() => {
						/* Nachdem alle Tag-Aktionen nacheinander abgelaufen sind (Add, Remove),
							soll zusätzlich der aktuelle Tag-Stand angefragt werden,
							um an die IDs der dem Objekt neu zugeordneten Tags zu kommen */
						TaggerService.getTags(state.current.PKM_Objekt)
							.then((response) => {
								commit('updateObjectSetupCategories', response);
								resolve();
							})
							.catch(() => {
								reject();
							});
					})
					.catch(() => { /* TODO: Use (better) logging */ });
			});

			/* Alternativ, könnte man auch den State mit den neuen Tags aktualisieren,
				dann hätten wir aber die IDs der jeweiligen Tags nicht */
			/*
			commit('updateObjectSetupCategories', preparedTags);
			return ObjectSetupService.set(state.current.PKM_Objekt, 'rubriken', preparedTags);
			*/
		},

		updateObjectSetupMediaformats({ commit, state }, mediaformats) {
			const initialTagIDMap = {};
			Object.keys(state.current.tags.result).forEach((tagID) => {
				const currInitTag = state.current.tags.result[tagID];
				initialTagIDMap[currInitTag.S_Value] = tagID;
			});

			/* Sofern der Tag und seine ID bereits bekannt sein,
				dann setzen wir sie hier nochmal, da es sein kann,
				dass die von der Sidebar überreichten Tags keine ID vorweisen können */
			Object.keys(mediaformats.tags).forEach((tag) => {
				const currTag = mediaformats.tags[tag];
				if (initialTagIDMap[tag]) {
					mediaformats.tags[tag].id = initialTagIDMap[tag];
				}

				/* Tag-Aktionen überspringen, bei denen Tags entfernt werden sollen,
					die keine ID besitzen -> wahrscheinlich ein Tag,
					der hinzugefügt und dann wieder entfernt wurde */
				if (currTag.action === 'remove' && currTag.id === null) {
					delete mediaformats.tags[tag];
				}
			});

			const tagSetPromises = Object.keys(mediaformats.tags).map((tag) => {
				const currTag = mediaformats.tags[tag];

				if (currTag.action === 'add') {
					return TaggerService.setTag(state.current.PKM_Objekt, currTag.value, 'medienformat');
				}

				return TaggerService.deleteTag(currTag.id, currTag.value);
			});

			const promisifiedTagActions = Promise.all(tagSetPromises);

			return new Promise((resolve, reject) => {
				promisifiedTagActions
					.then(() => {
						/* Nachdem alle Tag-Aktionen nacheinander abgelaufen sind (Add, Remove),
							soll zusätzlich der aktuelle Tag-Stand angefragt werden,
							um an die IDs der dem Objekt neu zugeordneten Tags zu kommen */
						TaggerService.getTags(state.current.PKM_Objekt)
							.then((response) => {
								console.log('getTags - Success!', response);
								commit('updateObjectSetupMediaformats', response);
								resolve();
							})
							.catch((response) => {
								console.log('getTags - Fail!', response);
								reject();
							});
					})
					.catch(() => {
						console.error('Tag-Aktionen fehlgeschlagen!');
					});
			});
		},

		updateObjectProjectToCountry({ commit, state }, countryId) {
			return new Promise((resolve, reject) => {
				ObjectSetupService.setProjectToCountry(state.current.PKM_Objekt, countryId.objectcountry)
				.then(() => {
					commit('updateObjectProjectToCountry', countryId.objectcountry);
					resolve();
				})
				.catch((response) => {
					reject(response);
				});
			});
		},

		triggerIdTextRTFExport({ state }) {
			return ObjectSetupService.getIdTextRTFExport(state.current.PKM_Objekt, state.language);
		},
	},

	getters: {
		objectname(state) {
			return (state.current && state.current[`S_${state.language}_Objekt`]) || '';
		},

		themeIdToOrder(state) {
			const themeIdOrderMap = {};

			(state.current.themen || []).forEach((theme) => {
				const themeId = theme.PKM_Thema;
				const orderNum = parseInt(theme.U_Reihenfolge, 10);
				themeIdOrderMap[themeId] = orderNum;
			});

			return themeIdOrderMap;
		},

		topicIds(state) {
			const sites = state.current.seiten || [];
			return Object.keys(sites.reduce((topicIds, site) => {
				const topicId = parseInt(site.FKM_Thema, 10);
				topicIds[topicId] = true;
				return topicIds;
			}, {}));
		},

		objectIsProductive(state, getters) {
			return ObjectHelper.isProductive(state.current, getters.statiAssoc);
		},

		visitableObjectPreviewUrl(state) {
			return ObjectHelper.previewUrl(state.current, state.language);
		},

		visitableObjectOnlineUrl(state) {
			return ObjectHelper.onlineUrl(state.current, state.language);
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/objectsetup.js